import { OrganizationProfileLink, OrganizationProfilePage } from '../OrganizationProfile';
import _OrganizationSwitcher from './OrganizationSwitcher.vue';

export const OrganizationSwitcher = Object.assign(_OrganizationSwitcher, {
  OrganizationProfilePage,
  OrganizationProfileLink,
});
